
import BB8, { resize as BB8Resize} from './bb8';
import Millenium, { resize as MilleniumResize} from './millenium-falcon';
import CaptainAmerica, { resize as CaptainAmericaResize} from './captain-america';
import USSEnterprise, { resize as USSEnterpriseResize} from './uss-enterprise';
import MinimalistTurtle, { resize as MinimalistTurtleResize} from './minimalist/turtle';
import MinimalistToucan, { resize as MinimalistToucanResize} from './minimalist/toucan';
import MinimalistWhale, { resize as MinimalistWhaleResize} from './minimalist/whale';
import MinimalistLadyBug, { resize as MinimalistLadyBugResize} from './minimalist/lady-bug';
import MinimalistCrab, { resize as MinimalistCrabResize} from './minimalist/crab';
import MinimalistFox, { resize as MinimalistFoxResize} from './minimalist/fox';
import MinimalistPig, { resize as MinimalistPigResize} from './minimalist/pig';

import RootsPig, { resize as RootsPigResize } from './rootstech/pig';
import RootsPeacock, { resize as RootsPeacockResize } from './rootstech/peacock';
import RootsDog, { resize as RootsDogResize } from './rootstech/dog';
import RootsPanda, { resize as RootsPandaResize, RootsPandaOverlay } from './rootstech/panda';
import RootsPirateShip, { resize as RootsPirateShipResize } from './rootstech/pirate-ship';
import RootsVikingShip, { resize as RootsVikingShipResize } from './rootstech/viking-ship';
import RootsSunflower, { resize as RootsSunflowerResize } from './rootstech/sunflower';
import RootsSunrise, { resize as RootsSunriseResize } from './rootstech/sunrise';
import RootsUnicorn, { resize as RootsUnicornResize, RootsUnicornOverlay } from './rootstech/unicorn';
import RootsDinosaur, { resize as RootsDinosaurResize } from './rootstech/dinosaur';


import SafariGiraffe, { resize as SafariGiraffeResize} from './safari/giraffe';
import SafariHippo, { resize as SafariHippoResize} from './safari/hippo';

import DiaDeLosMuertos, { resize as DiaDeLosMuertosResize} from './dia-de-los-muertos';
import DiaDeLosMuertosSkull, { resize as DiaDeLosMuertosSkullResize} from './dia-de-los-muertos-skull';
import TreeRoots, { resize as TreeRootsResize} from './tree-roots';

export default {
  bb8: {
    component: BB8,
    resize: BB8Resize,
  },
  'millenium-falcon': {
    component: Millenium,
    resize: MilleniumResize,
  },
  'captain-america': {
    component: CaptainAmerica,
    resize: CaptainAmericaResize,
  },
  'uss-enterprise': {
    component: USSEnterprise,
    resize: USSEnterpriseResize,
  },
  'minimalist-turtle': {
    component: MinimalistTurtle,
    resize: MinimalistTurtleResize,
  },
  'minimalist-toucan': {
    component: MinimalistToucan,
    resize: MinimalistToucanResize,
  },
  'minimalist-whale': {
    component: MinimalistWhale,
    resize: MinimalistWhaleResize,
  },
  'minimalist-lady-bug': {
    component: MinimalistLadyBug,
    resize: MinimalistLadyBugResize,
  },
  'minimalist-crab': {
    component: MinimalistCrab,
    resize: MinimalistCrabResize,
  },
  'minimalist-fox': {
    component: MinimalistFox,
    resize: MinimalistFoxResize,
  },
  'minimalist-pig': {
    component: MinimalistPig,
    resize: MinimalistPigResize,
  },

  'safari-giraffe': {
    component: SafariGiraffe,
    resize: SafariGiraffeResize,
  },
  'safari-hippo': {
    component: SafariHippo,
    resize: SafariHippoResize,
  },
  'tree-roots': {
    component: TreeRoots,
    resize: TreeRootsResize,
  },
  'pig': {
    component: RootsPig,
    resize: RootsPigResize,
  },
  'peacock': {
    component: RootsPeacock,
    resize: RootsPeacockResize,
  },
  'dog': {
    component: RootsDog,
    resize: RootsDogResize,
  },
  'panda': {
    component: RootsPanda,
    overlay: RootsPandaOverlay,
    resize: RootsPandaResize,
  },
  'pirate-ship': {
    component: RootsPirateShip,
    resize: RootsPirateShipResize,
  },
  'viking-ship': {
    component: RootsVikingShip,
    resize: RootsVikingShipResize,
  },
  'sunflower': {
    component: RootsSunflower,
    resize: RootsSunflowerResize,
  },
  'sunrise': {
    component: RootsSunrise,
    resize: RootsSunriseResize,
  },
  'unicorn': {
    component: RootsUnicorn,
    overlay: RootsUnicornOverlay,
    resize: RootsUnicornResize,
  },
  'dinosaur': {
    component: RootsDinosaur,
    resize: RootsDinosaurResize,
  },
  'dia-de-los-muertos': {
    component: DiaDeLosMuertos,
    resize: DiaDeLosMuertosResize,
  },
  'dia-de-los-muertos-skull': {
    overlay: DiaDeLosMuertosSkull,
    resize: DiaDeLosMuertosSkullResize,
  },
}


// WEBPACK FOOTER //
// ./src/core/thematic/index.js